<template>
  <v-container
    fill-height
    fluid
    style="flex-wrap: wrap;"
  >
    <v-flex
      md12
    >

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://kaki-playground.com/"
              target="_blank"
            >
              公園を中心とした、子供と遊ぶ場所をピックアップしていくサイト
            </a>
          </div>
        </div>
        <div>
          【かき ぷれいぐらうんど】<br>
          <a
            href="https://kaki-playground.com/"
            target="_blank">https://kaki-playground.com/</a>
        </div>
        <br>
        <div>
          コンセプトは、<br>
          「歩いて行ける、子供と遊ぶ場所！」（福岡市周辺）
        </div>
        <br>
        <div>
          Gatsby（React）を使ってます。
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://kakisoft.github.io/WerewolfGameInEnglish/"
              target="_blank"
            >
              人狼ゲーム用語集（英語）
            </a>
          </div>
        </div>
        <div>
          英語で人狼ゲームをやって遊ぶコミュニティに提供中。自分も使ってます。<br>
          <a
            href="https://kakisoft.github.io/WerewolfGameInEnglish/"
            target="_blank">https://kakisoft.github.io/WerewolfGameInEnglish/</a>
        </div>
        <br>
        <div>
          管理者はキーワードが追加できるなどの機能を追加予定。
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://another-name-generator.netlify.com/"
              target="_blank"
            >
              異名ジェネレータ
            </a>
          </div>
        </div>
        <div>
          ランダムに言葉を生成して、適当な異名を探す。<br>
          <a
            href="https://another-name-generator.netlify.com/"
            target="_blank">https://another-name-generator.netlify.com/</a>
        </div>
        <br>
        <div>
          Vue.js で何か作ってみようと思って作りました。<br>
          ちなみに、このサイトも Vue.js を使っています。
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://csv-to-table.netlify.com/"
              target="_blank"
            >
              CSV to TABLE
            </a>
          </div>
        </div>
        <div>
          CSV をテキストエリアに入力したら、ちょっといい感じにテーブル化する。<br>
          <a
            href="https://csv-to-table.netlify.com/"
            target="_blank">https://csv-to-table.netlify.com/</a>
        </div>
        <br>
        <div>
          DLして遊ぼうと思ってたデータがCSV形式だったんで、その過程で作ってみた。<br>
          同じく、Vue.js で何か作ってみようと思って作りました。
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://kakisoft-tmp-portfolio.studio.site/"
              target="_blank"
            >
              情報量ゼロのポートフォリオサイト
            </a>
          </div>
        </div>
        <div>
          ネタで作成したポートフォリオサイト。見た目だけはちょっと良さげ。<br>
          <a
            href="https://kakisoft-tmp-portfolio.studio.site/"
            target="_blank">https://kakisoft-tmp-portfolio.studio.site/</a>
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://atarima-e.studio.site/"
              target="_blank"
            >
              良さげな画像と適当な英語を並べて、何だかいい感じのサイトっぽくする
            </a>
          </div>
        </div>
        <div>
          ネタサイト。一見、「こんなクールなサイトができたぜ！」と錯覚させる事ができました。<br>
          <a
            href="https://atarima-e.studio.site/"
            target="_blank">https://atarima-e.studio.site/</a>
        </div>
      </material-card>

      <material-card color="green">
        <div slot="header">
          <div class="title font-weight-light mb-2">
            <a
              class="white--text myfont01"
              href="https://kakisoft-portfolio-en-03-20dd0.netlify.app/"
              target="_blank"
            >
              英語版ポートフォリオ（非エンジニア向け） / English portfolio(for lay people)
            </a>
          </div>
        </div>
        <div>
          <p>
            オンライン英会話予約時の自己紹介欄に、会話のネタにならないかとポートフォリオへのリンクを貼ってるけど、見てくれる人が３割で、そのうち半分は「日本語分かんねーんだわ。」と冷ややかな反応だったので、
            英語版ポートフォリオを作ってみた。<br>
            <a
              href="https://kakisoft-portfolio-en-03-20dd0.netlify.app/"
              target="_blank">https://kakisoft-portfolio-en-03-20dd0.netlify.app/</a>
          </p>
          <p>
            きっかりしたものを作ろうかと思ったが、英語学習用（見るのはエンジニアでない）と、テクニカルな内容を記述するサイトとは分けたほうがよさそうだったので、分ける事にした。<br>
            テクニカルな内容を書くのは別途作成予定。
          </p>
          <p>
            ちなみに使ったのは、
            <a
              href="https://stackbit.com/"
              target="_blank">Stackbit</a>
            という Jamstack な webサービス。
          </p>
          <p>
            この手のサービス、本当に選択肢が豊富になってきたな。
          </p>
          <hr>
          <p>
            When I book English lesson online, I put a link of my portfolio in self introduction.
          </p>
          <p>
            But Only about 30% of tutors check it. And also, half of them respond coldly, saying, "I don't understand Japanese."
          </p>
          <p>
            So, I created a English portfolio.
          </p>
          <p>
            First, I try to create it properly.
          </p>
          <p>
            But, I thought to created website for lay people, so I made simple website.
          </p>
          <p>
            I will create technical a portfolio.
          </p>
        </div>
      </material-card>

    </v-flex>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    icons: [
      'mdi-access-point',
      'mdi-access-point-network',
      'mdi-account',
      'mdi-account-alert',
      'mdi-account-box',
      'mdi-account-box-multiple',
      'mdi-account-box-outline',
      'mdi-account-card-details',
      'mdi-account-check',
      'mdi-account-circle',
      'mdi-account-convert',
      'mdi-account-edit',
      'mdi-account-group',
      'mdi-account-heart',
      'mdi-account-key',
      'mdi-account-location',
      'mdi-account-minus',
      'mdi-account-multiple',
      'mdi-account-multiple-check',
      'mdi-account-multiple-minus',
      'mdi-account-multiple-outline',
      'mdi-account-multiple-plus',
      'mdi-account-multiple-plus-outline',
      'mdi-account-network',
      'mdi-account-off',
      'mdi-account-outline',
      'mdi-account-plus',
      'mdi-account-plus-outline',
      'mdi-account-remove',
      'mdi-account-search',
      'mdi-account-search-outline',
      'mdi-account-settings',
      'mdi-account-settings-variant',
      'mdi-account-star',
      'mdi-account-switch',
      'mdi-accusoft',
      'mdi-adjust',
      'mdi-adobe',
      'mdi-air-conditioner',
      'mdi-airballoon',
      'mdi-airplane',
      'mdi-airplane-landing',
      'mdi-airplane-off',
      'mdi-airplane-takeoff',
      'mdi-airplay',
      'mdi-airport',
      'mdi-alarm',
      'mdi-alarm-bell',
      'mdi-alarm-check',
      'mdi-alarm-light',
      'mdi-alarm-multiple',
      'mdi-alarm-off',
      'mdi-alarm-plus',
      'mdi-alarm-snooze',
      'mdi-album',
      'mdi-alert',
      'mdi-alert-box',
      'mdi-alert-circle',
      'mdi-alert-circle-outline',
      'mdi-alert-decagram',
      'mdi-alert-octagon',
      'mdi-alert-octagram',
      'mdi-alert-outline',
      'mdi-alien',
      'mdi-all-inclusive',
      'mdi-alpha',
      'mdi-alphabetical',
      'mdi-altimeter',
      'mdi-amazon',
      'mdi-amazon-alexa',
      'mdi-amazon-drive',
      'mdi-ambulance',
      'mdi-amplifier',
      'mdi-anchor',
      'mdi-android',
      'mdi-android-debug-bridge',
      'mdi-android-head',
      'mdi-android-studio',
      'mdi-angle-acute',
      'mdi-angle-obtuse',
      'mdi-angle-right',
      'mdi-angular',
      'mdi-angularjs',
      'mdi-animation',
      'mdi-animation-play',
      'mdi-anvil',
      'mdi-apple',
      'mdi-apple-finder',
      'mdi-apple-icloud',
      'mdi-apple-ios',
      'mdi-apple-keyboard-caps',
      'mdi-apple-keyboard-command',
      'mdi-apple-keyboard-control',
      'mdi-apple-keyboard-option',
      'mdi-apple-keyboard-shift',
      'mdi-apple-safari',
      'mdi-application',
      'mdi-approval',
      'mdi-apps',
      'mdi-arch',
      'mdi-archive',
      'mdi-arrange-bring-forward',
      'mdi-arrange-bring-to-front',
      'mdi-arrange-send-backward',
      'mdi-arrange-send-to-back',
      'mdi-arrow-all',
      'mdi-arrow-bottom-left',
      'mdi-arrow-bottom-left-bold-outline',
      'mdi-arrow-bottom-left-thick',
      'mdi-arrow-bottom-right',
      'mdi-arrow-bottom-right-bold-outline',
      'mdi-arrow-bottom-right-thick',
      'mdi-arrow-collapse',
      'mdi-arrow-collapse-all',
      'mdi-arrow-collapse-down',
      'mdi-arrow-collapse-horizontal',
      'mdi-arrow-collapse-left',
      'mdi-arrow-collapse-right',
      'mdi-arrow-collapse-up',
      'mdi-arrow-collapse-vertical',
      'mdi-arrow-decision',
      'mdi-arrow-decision-auto',
      'mdi-arrow-decision-auto-outline',
      'mdi-arrow-decision-outline',
      'mdi-arrow-down',
      'mdi-arrow-down-bold',
      'mdi-arrow-down-bold-box',
      'mdi-arrow-down-bold-box-outline',
      'mdi-arrow-down-bold-circle',
      'mdi-arrow-down-bold-circle-outline',
      'mdi-arrow-down-bold-hexagon-outline',
      'mdi-arrow-down-bold-outline',
      'mdi-arrow-down-box',
      'mdi-arrow-down-drop-circle',
      'mdi-arrow-down-drop-circle-outline',
      'mdi-arrow-down-thick',
      'mdi-arrow-expand',
      'mdi-arrow-expand-all',
      'mdi-arrow-expand-down',
      'mdi-arrow-expand-horizontal',
      'mdi-arrow-expand-left',
      'mdi-arrow-expand-right',
      'mdi-arrow-expand-up',
      'mdi-arrow-expand-vertical',
      'mdi-arrow-left',
      'mdi-arrow-left-bold',
      'mdi-arrow-left-bold-box',
      'mdi-arrow-left-bold-box-outline',
      'mdi-arrow-left-bold-circle',
      'mdi-arrow-left-bold-circle-outline',
      'mdi-arrow-left-bold-hexagon-outline',
      'mdi-arrow-left-bold-outline',
      'mdi-arrow-left-box',
      'mdi-arrow-left-drop-circle',
      'mdi-arrow-left-drop-circle-outline',
      'mdi-arrow-left-right-bold-outline',
      'mdi-arrow-left-thick',
      'mdi-arrow-right',
      'mdi-arrow-right-bold',
      'mdi-arrow-right-bold-box',
      'mdi-arrow-right-bold-box-outline',
      'mdi-arrow-right-bold-circle',
      'mdi-arrow-right-bold-circle-outline',
      'mdi-arrow-right-bold-hexagon-outline',
      'mdi-arrow-right-bold-outline',
      'mdi-arrow-right-box',
      'mdi-arrow-right-drop-circle',
      'mdi-arrow-right-drop-circle-outline',
      'mdi-arrow-right-thick',
      'mdi-arrow-split-horizontal',
      'mdi-arrow-split-vertical',
      'mdi-arrow-top-left',
      'mdi-arrow-top-left-bold-outline',
      'mdi-arrow-top-left-thick',
      'mdi-arrow-top-right',
      'mdi-arrow-top-right-bold-outline',
      'mdi-arrow-top-right-thick',
      'mdi-arrow-up',
      'mdi-arrow-up-bold',
      'mdi-arrow-up-bold-box',
      'mdi-arrow-up-bold-box-outline',
      'mdi-arrow-up-bold-circle',
      'mdi-arrow-up-bold-circle-outline',
      'mdi-arrow-up-bold-hexagon-outline',
      'mdi-arrow-up-bold-outline',
      'mdi-arrow-up-box',
      'mdi-arrow-up-down-bold-outline',
      'mdi-arrow-up-drop-circle',
      'mdi-arrow-up-drop-circle-outline',
      'mdi-arrow-up-thick',
      'mdi-artist',
      'mdi-assistant',
      'mdi-asterisk',
      'mdi-at',
      'mdi-atlassian',
      'mdi-atom',
      'mdi-attachment',
      'mdi-audio-video',
      'mdi-audiobook',
      'mdi-augmented-reality',
      'mdi-auto-fix',
      'mdi-auto-upload',
      'mdi-autorenew',
      'mdi-av-timer',
      'mdi-axe',
      'mdi-azure',
      'mdi-baby',
      'mdi-baby-buggy',
      'mdi-backburger',
      'mdi-backspace',
      'mdi-backup-restore',
      'mdi-badminton'
    ]
  })
}
</script>
